'use client';
import Link from "next/link";
import React, { forwardRef, useEffect, useState } from 'react';
import { translateHrefWithLocale } from "./translateHrefUtil.js";


function getCookie(name) {
    if (typeof document === 'undefined') return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}


const LocalizedLink = ({ href, children, ...props }, ref) => {
    const [translatedPath, setTranslatedPath] = useState('nl-NL');

    useEffect(()=>{
        setTranslatedPath(translateHrefWithLocale(href, getCookie('NEXT_LOCALE')))
    },[href])

    if (ref) {
        return (
            <Link href={translatedPath} legacyBehavior>
                <a ref={ref} {...props}>{children}</a>
            </Link>
        );
    }
    return <Link href={translatedPath} {...props}>{children}</Link>;
}

const LocalizedLinkClient = forwardRef(LocalizedLink);

export default LocalizedLinkClient;
